"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Inbox/ChatSearchPane/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _upgrade = require('shared/enum/upgrade');
var _useSearchQuery = require('shared/hooks/useSearchQuery');
var _myRelations = require('shared/selectors/myRelations');





var _user = require('shared/selectors/user');





var _actions3 = require('web/actions'); var _actions4 = _interopRequireDefault(_actions3);
var _hooks = require('web/services/hooks');
var _responsive = require('web/services/responsive');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);
var _UpgradeModal = require('web/components/Upgrade/UpgradeModal'); var _UpgradeModal2 = _interopRequireDefault(_UpgradeModal);
var _Header = require('web/components/RightSide/Header');

var _icons = require('web/screens/Search/Refined/icons');
var _searchSession = require('web/screens/Search/Refined/searchSession');
var _ChatSearchResultItem = require('./ChatSearchResultItem'); var _ChatSearchResultItem2 = _interopRequireDefault(_ChatSearchResultItem);

const PAGE_SIZE = 10




const INITIAL_PAGING = {
  message: { page: 0, hasMore: false },
  file: { page: 0, hasMore: false },
}



















const rowsFromMap = (results, resultType) =>
  Object.entries(results).map(([MessageKey, result]) => ({
    resultType,
    MessageKey,
    TimeStamp: result.TimeStamp,
    Title: result.Title,
    Subtitle: result.Subtitle,
    SenderKey: result.SenderKey,
    SenderName: result.SenderName,
    SenderType: result.SenderType,
    SenderAvatar: result.SenderAvatar,
    SenderRemoved: result.SenderRemoved,
  } ))

const mergeRows = (existing, incoming) => {
  const rows = new Map()
  for (const row of [...existing, ...incoming]) {
    rows.set(`${row.resultType}:${row.MessageKey}`, row)
  }
  return [...rows.values()].sort((a, b) =>
    new Date(b.TimeStamp).getTime() - new Date(a.TimeStamp).getTime(),
  )
}

 const ChatSearchPane = ({
  conversationKey,
  conversationType,
  blobjectKey,
  onClose,
  isOpen = true,
  canDoAdvancedSearch,
  useTestAlias,
  mySingleOrgKey,
  canUpgrade,
  myUserKey,
}) => {
  const [query, setQuery] = _react.useState.call(void 0, '')
  const [latestQuery, setLatestQuery] = _react.useState.call(void 0, '')
  const [results, setResults] = _react.useState([])
  const [paging, setPaging] = _react.useState(INITIAL_PAGING)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [hasSearched, setHasSearched] = _react.useState.call(void 0, false)
  const [searchError, setSearchError] = _react.useState.call(void 0, false)
  const [isUpsellModalOpen, setIsUpsellModalOpen] = _react.useState.call(void 0, false)
  const [activeKey, setActiveKey] = _react.useState(null)
  const inputRef = _react.useRef(null)
  const queryEpochRef = _react.useRef.call(void 0, 0)
  const pagingRef = _react.useRef(INITIAL_PAGING)
  const paginationGenerationsRef = _react.useRef({ message: 0, file: 0 })
  const daysLimit = canDoAdvancedSearch ? 0 : 14

  const runSearch = _react.useCallback.call(void 0, (searchQuery, reset) => {
    if (!conversationKey || !searchQuery) return
    const resultTypes = reset
      ? ['message', 'file']
      : (['message', 'file'] ).filter(type => pagingRef.current[type].hasMore)
    if (!resultTypes.length) return

    const epoch = reset ? ++queryEpochRef.current : queryEpochRef.current
    if (reset) paginationGenerationsRef.current = { message: 0, file: 0 }
    const generations = {} 
    if (!reset) {
      resultTypes.forEach(type => {
        generations[type] = paginationGenerationsRef.current[type] + 1
        paginationGenerationsRef.current[type] = generations[type]
      })
    }
    const searchTypes = resultTypes.map(type => ({
      SearchType: type === 'message' ? 'text' : 'file',
      Take: PAGE_SIZE,
      Skip: reset ? 0 : (pagingRef.current[type].page + 1) * PAGE_SIZE,
    }))

    setIsLoading(true)
    setSearchError(false)
    _actions2.default.search(searchQuery, searchTypes, daysLimit, useTestAlias, conversationKey)
      .then(response => {
        if (epoch !== queryEpochRef.current) return
        const currentTypes = resultTypes.filter(type => reset ||
          generations[type] === paginationGenerationsRef.current[type])
        if (!currentTypes.length) return
        const incoming = currentTypes.flatMap(type => rowsFromMap(
          type === 'message' ? response.Messages.Results : response.Files.Results,
          type,
        ))
        setResults(previous => mergeRows(reset ? [] : previous, incoming))
        setPaging(previous => {
          const next = { ...previous }
          currentTypes.forEach(type => {
            const result = type === 'message' ? response.Messages : response.Files
            next[type] = { page: reset ? 0 : previous[type].page + 1, hasMore: result.HasMore }
          })
          pagingRef.current = next
          return next
        })
        setLatestQuery(searchQuery)
        setHasSearched(true)
        setIsLoading(false)
      })
      .catch(() => {
        if (epoch !== queryEpochRef.current) return
        if (!reset && !resultTypes.some(type =>
          generations[type] === paginationGenerationsRef.current[type])) return
        setLatestQuery(searchQuery)
        setHasSearched(true)
        setIsLoading(false)
        setSearchError(true)
      })
  }, [conversationKey, daysLimit, useTestAlias])

  _react.useEffect.call(void 0, () => {
    queryEpochRef.current += 1
    if (!query) {
      setLatestQuery('')
      setResults([])
      setPaging(INITIAL_PAGING)
      pagingRef.current = INITIAL_PAGING
      setHasSearched(false)
      setIsLoading(false)
      setSearchError(false)
      return
    }
    setResults([])
    setPaging(INITIAL_PAGING)
    pagingRef.current = INITIAL_PAGING
    setHasSearched(false)
    setIsLoading(false)
    setSearchError(false)
    setActiveKey(null)
    const timer = window.setTimeout(() => runSearch(query, true), 500)
    return () => window.clearTimeout(timer)
  }, [query, runSearch])

  const hasMore = paging.message.hasMore || paging.file.hasMore

  // autoFocus would only fire on mount, and the pane now mounts once and is
  // hidden rather than unmounted, so focus follows the open transition instead.
  _react.useEffect.call(void 0, () => { if (isOpen) _optionalChain([inputRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.focus, 'call', _3 => _3()]) }, [isOpen])

  // Jumping to a result keeps the pane open so the next result is one click
  // away — the conversation and the pane sit side by side at desktop width.
  // Below the breakpoint the pane is a full-viewport overlay, where staying
  // open would hide the very message the user just jumped to, so there we
  // still close it.
  const handleResultActivated = _react.useCallback.call(void 0, 
    (result) => {
      setActiveKey(`${result.resultType}:${result.MessageKey}`)
      _searchSession.searchSession.setHit({ conversationKey, messageKey: result.MessageKey, query: latestQuery, fromWindow: false })
      if (_responsive.isRightSidePaneOverlay.call(void 0, )) onClose()
    },
    [onClose, conversationKey, latestQuery],
  )

  // ↑ and ↓ (keys or buttons) open the previous or next result.
  const activeIndex = results.findIndex(r => `${r.resultType}:${r.MessageKey}` === activeKey)
  const step = _react.useCallback.call(void 0, (by) => {
    if (!results.length) return
    const next = results[activeIndex === -1 ? 0 : Math.min(Math.max(activeIndex + by, 0), results.length - 1)]
    if (!next) return
    _actions4.default.gotoBlobject(conversationType, conversationKey, blobjectKey, next.MessageKey)
    handleResultActivated(next)
  }, [results, activeIndex, conversationType, conversationKey, blobjectKey, handleResultActivated])
  const stepUp = _react.useCallback.call(void 0, () => step(-1), [step])
  const stepDown = _react.useCallback.call(void 0, () => step(1), [step])

  const onInputKeyDown = (event) => {
    if (event.key === 'Escape') onClose()
    if (event.key === 'ArrowDown' || (event.key === 'Enter' && activeIndex === -1)) {
      event.preventDefault()
      stepDown()
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      stepUp()
    }
  }

  return (
    _react2.default.createElement('section', { className: "chat-search chat-search---refined" , 'aria-label': "Search this conversation"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 234}}
      , _react2.default.createElement(_Header.RightSideHeader, { className: "blmh-desktop-hide", __self: this, __source: {fileName: _jsxFileName, lineNumber: 235}}
        , _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 236}} )
        , _react2.default.createElement(_Header.RightSideHeaderHeading, { title: "Search conversation" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}} )
      )
      , _react2.default.createElement('div', { className: "chat-search--input-wrap", __self: this, __source: {fileName: _jsxFileName, lineNumber: 239}}
        , _react2.default.createElement('img', { src: "/assets/icons/header/search-dark.svg", alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}} )
        , _react2.default.createElement('input', {
          ref: inputRef,
          'aria-label': "Search messages and files"   ,
          placeholder: "Search this conversation"  ,
          value: query,
          onChange: event => setQuery(_useSearchQuery.sanitizeSearchQuery.call(void 0, event.target.value)),
          onKeyDown: onInputKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}}
        )
        , query && _react2.default.createElement('button', { type: "button", 'aria-label': "Clear search" , onClick: () => setQuery(''), __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}}, "×")
      )

      , !query && _react2.default.createElement('div', { className: "chat-search--prompt", __self: this, __source: {fileName: _jsxFileName, lineNumber: 252}}, "Search messages and files in this conversation."      )
      , isLoading && !results.length && _react2.default.createElement('div', { className: "chat-search--status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 253}}, "Searching…")
      , searchError && (
        _react2.default.createElement('div', { className: "chat-search--status", role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}, "Search is temporarily unavailable. Please try again."      )
          , _react2.default.createElement('button', { type: "button", onClick: () => runSearch(latestQuery || query, true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}, "Retry")
        )
      )
      , !searchError && hasSearched && !isLoading && !results.length && (
        _react2.default.createElement('div', { className: "chat-search--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}
          , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}, canDoAdvancedSearch
            ? `No results found for \u201C${latestQuery}\u201D.`
            : `No results found in the last 14 days for \u201C${latestQuery}\u201D.`)
          , !canDoAdvancedSearch && (
            _react2.default.createElement(_WarningBar2.default, {
              text: "Your plan only includes access to the last 14 days of history."           ,
              linkText: canUpgrade ? 'Upgrade now' : undefined,
              onLinkClick: () => setIsUpsellModalOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
            )
          )
        )
      )
      , !searchError && !!results.length && (
        _react2.default.createElement('div', { className: "chat-search--results", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
          , _react2.default.createElement('div', { className: "chat-search--results-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 277}}
              , results.length === 1 ? '1 result in this chat' : `${results.length} results in this chat`
            )
            , _react2.default.createElement('span', { className: "chat-search--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}
              , _react2.default.createElement('button', { type: "button", 'aria-label': "Previous result" , onClick: stepUp, disabled: activeIndex <= 0, __self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
                , _react2.default.createElement(_icons.ChevronUpIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}} )
              )
              , _react2.default.createElement('button', { type: "button", 'aria-label': "Next result" , onClick: stepDown, disabled: activeIndex >= results.length - 1, __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}
                , _react2.default.createElement(_icons.ChevronDownIcon, { size: 16, __self: this, __source: {fileName: _jsxFileName, lineNumber: 285}} )
              )
            )
          )
          , results.map(result => (
            _react2.default.createElement(_ChatSearchResultItem2.default, {
              key: `${result.resultType}:${result.MessageKey}`,
              result: result,
              query: latestQuery,
              conversationType: conversationType,
              conversationKey: conversationKey,
              blobjectKey: blobjectKey,
              onActivate: handleResultActivated,
              myUserKey: myUserKey,
              active: `${result.resultType}:${result.MessageKey}` === activeKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
            )
          ))
          , hasMore && (
            _react2.default.createElement('button', { className: "chat-search--load-more", type: "button", disabled: isLoading, onClick: () => runSearch(latestQuery, false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 303}}
              , isLoading ? 'Loading…' : 'Load more'
            )
          )
          , !canDoAdvancedSearch && (
            _react2.default.createElement(_WarningBar2.default, {
              className: "chat-search--limit",
              text: "Your plan only includes access to the last 14 days of history."           ,
              linkText: canUpgrade ? 'Upgrade now' : undefined,
              onLinkClick: () => setIsUpsellModalOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 308}}
            )
          )
        )
      )
      , mySingleOrgKey && (
        _react2.default.createElement(_UpgradeModal2.default, {
          type: _upgrade.SubscriptionItemType.TEAM,
          isOpen: isUpsellModalOpen,
          onClose: () => setIsUpsellModalOpen(false),
          orgKey: mySingleOrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 318}}
        )
      )
    )
  )
}; exports.ChatSearchPane = ChatSearchPane

const ConnectedChatSearchPane = props => {
  const mySingleOrgKey = _hooks.useAppSelector.call(void 0, _myRelations.selectMySingleOrgKey)
  const canDoAdvancedSearch = _hooks.useAppSelector.call(void 0, _user.selectCanCurrentUserDoAdvancedSearch)
  const useTestAlias = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserHasTestSearchIteratorsFeature)
  const canUpgrade = _hooks.useAppSelector.call(void 0, state => {
    const orgKey = _myRelations.selectMySingleOrgKey.call(void 0, state)
    return !!orgKey && _user.selectAmIAdminInOrg.call(void 0, state, orgKey)
  })
  const myUserKey = _hooks.useAppSelector.call(void 0, _user.selectCurrentUserKey)

  return (
    _react2.default.createElement(exports.ChatSearchPane, {
      ...props,
      canDoAdvancedSearch: canDoAdvancedSearch,
      useTestAlias: useTestAlias,
      mySingleOrgKey: mySingleOrgKey,
      canUpgrade: canUpgrade,
      myUserKey: myUserKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 340}}
    )
  )
}

exports. default = _react.memo.call(void 0, ConnectedChatSearchPane)
